import type { CSVLine } from './validators'

export const CsvTemplate: CSVLine[] = [
  {
    Text: 'A post with text',
    'Image URL': undefined,
    Tags: undefined,
  },
  {
    Text: 'A post with text and an image',
    'Image URL': 'https://images.unsplash.com/photo-1745848413099-13adc3aaf308',
    Tags: undefined,
  },
  {
    Text: 'A post with text and tags - must be existing tags',
    'Image URL': undefined,
    Tags: 'tag1,tag2',
  },
]
